
    import './styles.scoped.css';
    export default {
  "variant-normal": "awsui_variant-normal_1a743_b1bxl_9",
  "pressed": "awsui_pressed_1a743_b1bxl_9",
  "variant-icon": "awsui_variant-icon_1a743_b1bxl_15"
};
  